import script from "./AdministratorProjectFormStep4.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectFormStep4.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectFormStep4.vue?vue&type=style&index=0&id=e1bc4d3c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1bc4d3c"]])

export default __exports__